import React from "react"
import { Link } from "gatsby"
import PortableText from "react-portable-text"
// import { Link } from "gatsby-plugin-react-i18next"
import Image from "gatsby-plugin-sanity-image"
// import getYouTubeId from "get-youtube-id"
// import YouTube from "react-youtube"

const PortableTextComp = ({ textData }) => {
  // const opts = {
  //   playerVars: {
  //     autoplay: 0,
  //   },
  // }z
  const serializer = {
    marks: { strong: props => <strong className="text-red-900" {...props} /> },
    link: props => {
      const { blank, href, children } = props
      return (
        <>
          {blank ? (
            <a
              href={href}
              className="text-red-900"
              target="_blank"
              rel="noopener noreferrer"
            >
              {children}
            </a>
          ) : (
            <Link to={href} className="text-red-900">
              {children}
            </Link>
          )}
        </>
      )
    },
    image: props => {
      return (
        <Image
          // pass asset, hotspot, and crop fields
          {...props}
          // tell Sanity how large to make the image (does not set any CSS)
          width={300}
          height={200}
          alt={props.alt || "Finanzas de Bolsillo"}
          className="rounded"
          // style it how you want it
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      )
    },
    // youtube: props => {
    //   const { url } = props
    //   const id = getYouTubeId(url)
    //   return (
    //     <div className="relative">
    //       <YouTube
    //         opts={opts}
    //         videoId={id}
    //         className="w-full h-44 xl:h-96 top-0 left-0 rounded"
    //       />
    //     </div>
    //   )
    // },
  }
  return (
    <PortableText
      className="font-roboto line-clamp-6 pt-3 text-xl"
      content={textData}
      serializers={serializer}
    />
  )
}

export default PortableTextComp
